/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListReferentialQuickMessage } from '../models/api-response-list-referential-quick-message';
import { ApiResponsePagedResultReferentialQuickMessage } from '../models/api-response-paged-result-referential-quick-message';
import { ApiResponseReferentialQuickMessage } from '../models/api-response-referential-quick-message';
import { createReferentialQuickMessage } from '../fn/referential-quick-message-api/create-referential-quick-message';
import { CreateReferentialQuickMessage$Params } from '../fn/referential-quick-message-api/create-referential-quick-message';
import { deleteReferentialQuickMessage } from '../fn/referential-quick-message-api/delete-referential-quick-message';
import { DeleteReferentialQuickMessage$Params } from '../fn/referential-quick-message-api/delete-referential-quick-message';
import { getReferentialQuickMessageByRef } from '../fn/referential-quick-message-api/get-referential-quick-message-by-ref';
import { GetReferentialQuickMessageByRef$Params } from '../fn/referential-quick-message-api/get-referential-quick-message-by-ref';
import { listReferentialQuickMessage } from '../fn/referential-quick-message-api/list-referential-quick-message';
import { ListReferentialQuickMessage$Params } from '../fn/referential-quick-message-api/list-referential-quick-message';
import { searchReferentialQuickMessage } from '../fn/referential-quick-message-api/search-referential-quick-message';
import { SearchReferentialQuickMessage$Params } from '../fn/referential-quick-message-api/search-referential-quick-message';
import { updateReferentialQuickMessage } from '../fn/referential-quick-message-api/update-referential-quick-message';
import { UpdateReferentialQuickMessage$Params } from '../fn/referential-quick-message-api/update-referential-quick-message';

@Injectable({ providedIn: 'root' })
export class ReferentialQuickMessageApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getReferentialQuickMessageByRef()` */
  static readonly GetReferentialQuickMessageByRefPath = '/v1/api/ui/referential/quick-message/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferentialQuickMessageByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialQuickMessageByRef$Response(params: GetReferentialQuickMessageByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialQuickMessage>> {
    return getReferentialQuickMessageByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReferentialQuickMessageByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialQuickMessageByRef(params: GetReferentialQuickMessageByRef$Params, context?: HttpContext): Observable<ApiResponseReferentialQuickMessage> {
    return this.getReferentialQuickMessageByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialQuickMessage>): ApiResponseReferentialQuickMessage => r.body)
    );
  }

  /** Path part for operation `updateReferentialQuickMessage()` */
  static readonly UpdateReferentialQuickMessagePath = '/v1/api/ui/referential/quick-message/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReferentialQuickMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialQuickMessage$Response(params: UpdateReferentialQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialQuickMessage>> {
    return updateReferentialQuickMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateReferentialQuickMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialQuickMessage(params: UpdateReferentialQuickMessage$Params, context?: HttpContext): Observable<ApiResponseReferentialQuickMessage> {
    return this.updateReferentialQuickMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialQuickMessage>): ApiResponseReferentialQuickMessage => r.body)
    );
  }

  /** Path part for operation `deleteReferentialQuickMessage()` */
  static readonly DeleteReferentialQuickMessagePath = '/v1/api/ui/referential/quick-message/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteReferentialQuickMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReferentialQuickMessage$Response(params: DeleteReferentialQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteReferentialQuickMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteReferentialQuickMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReferentialQuickMessage(params: DeleteReferentialQuickMessage$Params, context?: HttpContext): Observable<void> {
    return this.deleteReferentialQuickMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createReferentialQuickMessage()` */
  static readonly CreateReferentialQuickMessagePath = '/v1/api/ui/referential/quick-message';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReferentialQuickMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialQuickMessage$Response(params: CreateReferentialQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialQuickMessage>> {
    return createReferentialQuickMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createReferentialQuickMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialQuickMessage(params: CreateReferentialQuickMessage$Params, context?: HttpContext): Observable<ApiResponseReferentialQuickMessage> {
    return this.createReferentialQuickMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialQuickMessage>): ApiResponseReferentialQuickMessage => r.body)
    );
  }

  /** Path part for operation `searchReferentialQuickMessage()` */
  static readonly SearchReferentialQuickMessagePath = '/v1/api/ui/referential/quick-message/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchReferentialQuickMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialQuickMessage$Response(params: SearchReferentialQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialQuickMessage>> {
    return searchReferentialQuickMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchReferentialQuickMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialQuickMessage(params: SearchReferentialQuickMessage$Params, context?: HttpContext): Observable<ApiResponsePagedResultReferentialQuickMessage> {
    return this.searchReferentialQuickMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultReferentialQuickMessage>): ApiResponsePagedResultReferentialQuickMessage => r.body)
    );
  }

  /** Path part for operation `listReferentialQuickMessage()` */
  static readonly ListReferentialQuickMessagePath = '/v1/api/ui/referential/quick-message/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReferentialQuickMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialQuickMessage$Response(params: ListReferentialQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListReferentialQuickMessage>> {
    return listReferentialQuickMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReferentialQuickMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialQuickMessage(params: ListReferentialQuickMessage$Params, context?: HttpContext): Observable<ApiResponseListReferentialQuickMessage> {
    return this.listReferentialQuickMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListReferentialQuickMessage>): ApiResponseListReferentialQuickMessage => r.body)
    );
  }

}
